import { useEffect, useState } from 'react';

import { Card } from '../../components/base/Card';
import { usePageTitle } from '../../contexts/PageTitleContext';
import { SectionLoading } from '../../components/shared/SectionLoading';
import { ReadingsDisplay } from '../../components/LiveView/ReadingsDisplay';
import { PendingActionContextProvider } from '../../contexts/PendingActionContext';
import { LiveReadingContextProvider } from '../../contexts/LiveReadingContext';
import { useUserContext } from '../../contexts/UserContext';
import { Seperator } from '../../components/base/Seperator';
import { ITemplateConfiguration } from '../../types/Template/Template';
import { ApplianceSettings } from '../../components/LiveView/LiveViewSettings/HardwareSettings';
import { ViewSettings } from '../../components/LiveView/LiveViewSettings/ViewSettings';
import { useApplianceLookups } from '../../hooks/useApplianceLookups';
import useAppliances from '../../data/appliance/useAppliances';
import { IAppliance } from '../../types/Appliance/Appliance';

export function LiveViewPage() {
  const { setPageTitle } = usePageTitle();
  const { isLoading } = useApplianceLookups();
  const { loading: userLoading } = useUserContext();
  const { appliances: allAppliances } = useAppliances();
  const [selectedAppliance, setSelectedAppliance] = useState<
    IAppliance | undefined
  >(undefined);
  const [selectedTemplate, setSelectedTemplate] = useState<
    ITemplateConfiguration | undefined
  >(undefined);
  const [noAppliance, setNoAppliance] = useState(false);
  const [tableView, setTableView] = useState(false);
  const [superAdminView, setSuperAdminView] = useState(false);

  const handleApplianceChange = (e: React.FormEvent<HTMLSelectElement>) => {
    const applianceId = e.currentTarget.value;
    const foundAppliance = allAppliances.data?.find(
      (appliance) => appliance.id === applianceId
    );

    setSelectedAppliance(foundAppliance);
  };

  useEffect(() => {
    setPageTitle('Live Readings', false);
  }, [setPageTitle]);

  useEffect(() => {
    if (!allAppliances.isLoading && allAppliances.data?.length) {
      if (!selectedAppliance) {
        setSelectedAppliance(allAppliances.data[0]);
      }
    } else if (!allAppliances.isLoading) {
      setNoAppliance(true);
    }
  }, [selectedAppliance, allAppliances.isLoading, allAppliances.data]);

  return noAppliance ? (
    <Card>
      <div className="h-24 flex items-center justify-center">
        <p>Create an Appliance to get started</p>
      </div>
    </Card>
  ) : !selectedAppliance || isLoading || userLoading ? (
    <SectionLoading />
  ) : (
    <PendingActionContextProvider>
      <LiveReadingContextProvider hardwareId={selectedAppliance.id}>
        <Card className="mb-6">
          <ApplianceSettings
            appliances={allAppliances.data!}
            selectedAppliance={selectedAppliance}
            onApplianceChange={handleApplianceChange}
          />
          <Seperator text="" />
          <ViewSettings
            selectedAppliance={selectedAppliance}
            tableView={tableView}
            setTableView={setTableView}
            selectedTemplate={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
            superAdminView={superAdminView}
            setSuperAdminView={setSuperAdminView}
          />
        </Card>
        <ReadingsDisplay
          selectedAppliance={selectedAppliance}
          selectedTemplate={selectedTemplate}
          superAdminView={superAdminView}
          tableView={tableView}
        />
      </LiveReadingContextProvider>
    </PendingActionContextProvider>
  );
}
